import { upsertInto } from '@/lib/array-utils'
import { ApplicationState } from '@/redux/stores/types'
import { PreTripRequest } from '@/travelsuit'

import { IAction } from '../actions/action-helpers'
import { TripRequestsTypes } from '../actions/actions.types'

type TripRequestsState = ApplicationState['tripRequests']

const emptyTripRequestsState: TripRequestsState = []

function tripRequestsReducer(state: TripRequestsState = emptyTripRequestsState, action: IAction): TripRequestsState {
	switch (action.type) {
		case TripRequestsTypes.SubmitTripRequest.SUCCESS:
			return upsertInto(state, action.payload as PreTripRequest, (r) => r.id)
		case TripRequestsTypes.DeleteTripRequest.SUCCESS:
			return state.filter((tripRequest) => tripRequest.id !== action.requestPayload?.id)
	}
	return state
}

export default tripRequestsReducer
